import Styles from "./Globalstyles";
import { BrowserRouter as Router } from "react-router-dom";
import BrowseRoutes from "./BrowseRoutes";

function App() {
	return (
		<div>
			<Router>
				<BrowseRoutes />
			</Router>
			<Styles />
		</div>
	);
}

export default App;
